import { comparisonData } from "@/mocks/categories";

export default function ComparisonSection() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="px-6 md:px-10 lg:px-16">
        <div className="mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 leading-[1.1] tracking-tight">
            Mulebuy Spreadsheet vs Manual Tracking
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl">
            See how the mulebuy spreadsheet compares to manual methods and other tracking tools
          </p>
        </div>

        <div className="overflow-x-auto">
          <div className="grid grid-cols-3 gap-3 md:gap-4 min-w-[600px]">
            <div className="rounded-t-lg overflow-hidden">
              <div className="bg-foreground-200 px-4 py-3 text-xs font-medium text-foreground-500 whitespace-nowrap">
                Feature
              </div>
            </div>
            <div className="rounded-t-lg overflow-hidden">
              <div className="bg-secondary-600 px-4 py-3 text-xs font-bold text-white whitespace-nowrap text-center">
                Mulebuy Spreadsheet
              </div>
            </div>
            <div className="rounded-t-lg overflow-hidden">
              <div className="bg-foreground-200 px-4 py-3 text-xs font-medium text-foreground-500 whitespace-nowrap text-center">
                Other Tools
              </div>
            </div>

            {comparisonData.map((row, idx) => (
              <>
                <div key={`feat-${idx}`} className={`px-4 py-3 text-xs md:text-sm text-foreground-500 whitespace-nowrap border-b border-background-200/70 ${idx % 2 === 0 ? "bg-background-50" : "bg-background-100/50"}`}>
                  {row.feature}
                </div>
                <div key={`mulebuy-${idx}`} className={`px-4 py-3 text-xs md:text-sm font-bold text-foreground-900 whitespace-nowrap text-center border-b border-background-200/70 ${idx % 2 === 0 ? "bg-background-50" : "bg-background-100/50"}`}>
                  {row.mulebuy}
                </div>
                <div key={`other-${idx}`} className={`px-4 py-3 text-xs md:text-sm text-foreground-500 whitespace-nowrap text-center border-b border-background-200/70 ${idx % 2 === 0 ? "bg-background-50" : "bg-background-100/50"}`}>
                  {row.other}
                </div>
              </>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}